function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TweetMenuTemplate = require('./tweet-menu.template');
var TweetMenu = /*#__PURE__*/function () {
  function TweetMenu(app, mod) {
    _classCallCheck(this, TweetMenu);
    this.app = app;
    this.mod = mod;
    this.menuEl = null;
    this.anchor = null;
    this.tweet = null;
    this.actions = [];
    this.isOpen = false;
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
    this.onScrollClose = this.onScrollClose.bind(this);
  }
  return _createClass(TweetMenu, [{
    key: "toggle",
    value: function toggle(_ref) {
      var anchor = _ref.anchor,
        tweet = _ref.tweet;
      if (this.isOpen && this.anchor === anchor) {
        this.close();
        return;
      }
      this.open({
        anchor: anchor,
        tweet: tweet
      });
    }
  }, {
    key: "open",
    value: function open(_ref2) {
      var _this = this;
      var anchor = _ref2.anchor,
        tweet = _ref2.tweet;
      if (!anchor || !tweet) {
        return;
      }
      this.close();
      this.anchor = anchor;
      this.tweet = tweet;
      this.actions = this.buildActions(tweet);
      this.app.browser.addElementToDom(TweetMenuTemplate(this));
      this.menuEl = document.querySelector('.tweet-menu');
      if (!this.menuEl) {
        this.close();
        return;
      }
      this.anchor.classList.add('active');
      this.positionMenu();
      this.attachMenuEvents();
      this.addDismissListeners();
      this.isOpen = true;
      requestAnimationFrame(function () {
        var _this$menuEl;
        (_this$menuEl = _this.menuEl) === null || _this$menuEl === void 0 || _this$menuEl.classList.add('is-open');
      });
    }
  }, {
    key: "close",
    value: function close() {
      if (this.anchor) {
        this.anchor.classList.remove('active');
      }
      if (this.menuEl) {
        this.menuEl.remove();
        this.menuEl = null;
      }
      this.removeDismissListeners();
      this.isOpen = false;
      this.anchor = null;
      this.tweet = null;
      this.actions = [];
    }
  }, {
    key: "buildActions",
    value: function buildActions(tweet) {
      var _this2 = this,
        _tweet$tx,
        _tweet$tx2,
        _this$app$modules,
        _this$app$modules$get;
      var username = tweet.username || tweet.handle || 'user';
      var isMine = Boolean(tweet.publicKey && tweet.publicKey === this.mod.publicKey);
      var actions = [];
      if (isMine) {
        actions.push({
          id: 'edit',
          icon: 'fa-pen',
          label: 'Edit tweet',
          handler: function handler() {
            return _this2.handleEdit(tweet);
          }
        }, {
          id: 'delete',
          icon: 'fa-trash',
          label: 'Delete tweet',
          handler: function handler() {
            return _this2.handleDelete(tweet);
          }
        });
      } else {
        actions.push({
          id: 'hide',
          icon: 'fa-eye-slash',
          label: 'Hide this tweet',
          handler: function handler() {
            return _this2.handleHide(tweet);
          }
        }, {
          id: 'block',
          icon: 'fa-ban',
          label: "Block ".concat(username),
          handler: function handler() {
            return _this2.handleBlock(tweet);
          }
        }, {
          id: 'report',
          icon: 'fa-flag',
          label: 'Report tweet',
          handler: function handler() {
            return _this2.handleReport(tweet);
          }
        });
      }
      actions.push({
        id: 'info',
        icon: 'fa-circle-info',
        label: 'Show info',
        handler: function handler() {
          return _this2.handleShowInfo(tweet);
        }
      });
      var sourceSignature = ((_tweet$tx = tweet.tx) === null || _tweet$tx === void 0 ? void 0 : _tweet$tx.signature) || tweet.signature;
      var context = {
        tweet: tweet,
        transaction: tweet.tx,
        root_tx_sig: tweet.thread_id || sourceSignature,
        source_tx_sig: sourceSignature,
        reporter_publickey: ((_tweet$tx2 = tweet.tx) === null || _tweet$tx2 === void 0 || (_tweet$tx2 = _tweet$tx2.from) === null || _tweet$tx2 === void 0 || (_tweet$tx2 = _tweet$tx2[0]) === null || _tweet$tx2 === void 0 ? void 0 : _tweet$tx2.publicKey) || tweet.publicKey || ''
      };
      var responders = ((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$get = _this$app$modules.getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'redsquare-tweet-menu', context)) || [];
      var seen = new Set(actions.map(function (action) {
        return action.id;
      }));
      var _iterator = _createForOfIteratorHelper(responders),
        _step;
      try {
        var _loop = function _loop() {
          var responder = _step.value;
          var id = String((responder === null || responder === void 0 ? void 0 : responder.id) || '').trim();
          var label = String((responder === null || responder === void 0 ? void 0 : responder.text) || (responder === null || responder === void 0 ? void 0 : responder.label) || '').trim();
          if (!id || !label || typeof responder.callback !== 'function' || seen.has(id)) {
            return 1; // continue
          }
          seen.add(id);
          actions.push({
            id: id,
            icon: responder.icon || 'fa-puzzle-piece',
            label: label,
            handler: function handler() {
              try {
                var _result$catch;
                var result = responder.callback(context);
                result === null || result === void 0 || (_result$catch = result["catch"]) === null || _result$catch === void 0 || _result$catch.call(result, function (err) {
                  return console.error('RedSquare tweet menu action failed:', err);
                });
              } catch (err) {
                console.error('RedSquare tweet menu action failed:', err);
              }
            }
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return actions;
    }
  }, {
    key: "handleHide",
    value: function handleHide(tweet) {
      if (typeof this.mod.hideTweet === 'function') {
        this.mod.hideTweet(tweet);
        return;
      }
      alert('Awaiting implementation...');
    }
  }, {
    key: "handleBlock",
    value: function handleBlock(tweet) {
      var publicKey = (tweet === null || tweet === void 0 ? void 0 : tweet.publicKey) || '';
      if (!publicKey || publicKey === this.mod.publicKey) {
        return;
      }
      this.app.connection.emit('saito-blacklist', {
        publicKey: publicKey
      });
    }
  }, {
    key: "handleReport",
    value: function () {
      var _handleReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tweet) {
        var tx, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!(tweet !== null && tweet !== void 0 && tweet.signature) || tweet.flagged == 1)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return this.mod.createFlagTweetTransaction({
                signature: tweet.signature
              });
            case 2:
              tx = _context.v;
              _context.n = 3;
              return this.app.network.sendRequestAsTransaction('flag tweet', tx.msg.data);
            case 3:
              tweet.flagged = 1;
              tweet.refresh();
              _context.p = 4;
              _context.n = 5;
              return this.mod.receiveFlagTweetTransaction(tx);
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error('RedSquare report archive update failed:', _t);
            case 7:
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t2 = _context.v;
              console.error('RedSquare report failed:', _t2);
              siteMessage('Unable to report tweet', 2500);
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[4, 6], [1, 8]]);
      }));
      function handleReport(_x) {
        return _handleReport.apply(this, arguments);
      }
      return handleReport;
    }()
  }, {
    key: "handleEdit",
    value: function handleEdit(tweet) {
      var _this$mod$compose_ove;
      if (!(tweet !== null && tweet !== void 0 && tweet.signature) || tweet.publicKey !== this.mod.publicKey) {
        return;
      }
      (_this$mod$compose_ove = this.mod.compose_overlay) === null || _this$mod$compose_ove === void 0 || _this$mod$compose_ove.open({
        mode: 'edit',
        tweet: tweet,
        text: tweet.text || ''
      });
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tweet) {
        var _tweet$tx3, keys, _iterator2, _step2, slip, unsigned, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!(tweet !== null && tweet !== void 0 && tweet.signature) || tweet.publicKey !== this.mod.publicKey)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              keys = [];
              _iterator2 = _createForOfIteratorHelper(((_tweet$tx3 = tweet.tx) === null || _tweet$tx3 === void 0 ? void 0 : _tweet$tx3.to) || []);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  slip = _step2.value;
                  if (slip !== null && slip !== void 0 && slip.publicKey && !keys.includes(slip.publicKey)) {
                    keys.push(slip.publicKey);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context2.n = 2;
              return this.mod.createDeleteTweetTransaction({
                tweet_id: tweet.signature
              }, keys);
            case 2:
              unsigned = _context2.v;
              _context2.n = 3;
              return unsigned.sign();
            case 3:
              _context2.n = 4;
              return this.app.network.propagateTransaction(unsigned);
            case 4:
              _context2.n = 5;
              return this.mod.receiveDeleteTweetTransaction(unsigned);
            case 5:
              siteMessage('Delete Request Broadcast: it may take a minute for your request to propagate...', 4000);
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t3 = _context2.v;
              console.error('RedSquare delete failed:', _t3);
              siteMessage('Unable to delete tweet', 2500);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleShowInfo",
    value: function handleShowInfo(tweet) {
      if (typeof this.mod.showTweetInfo === 'function') {
        this.mod.showTweetInfo(tweet);
        return;
      }
      alert('Awaiting implementation...');
    }
  }, {
    key: "positionMenu",
    value: function positionMenu() {
      if (!this.menuEl || !this.anchor) {
        return;
      }
      var margin = 8;
      var viewportWidth = window.innerWidth;
      var viewportHeight = window.innerHeight;
      var anchorRect = this.anchor.getBoundingClientRect();
      this.menuEl.style.visibility = 'hidden';
      this.menuEl.style.top = '0px';
      this.menuEl.style.left = '0px';
      var menuRect = this.menuEl.getBoundingClientRect();
      var top = anchorRect.bottom + margin;
      var left = anchorRect.right - menuRect.width;
      if (top + menuRect.height > viewportHeight - margin) {
        top = anchorRect.top - menuRect.height - margin;
      }
      if (top < margin) {
        top = margin;
      }
      if (left < margin) {
        left = margin;
      }
      if (left + menuRect.width > viewportWidth - margin) {
        left = viewportWidth - menuRect.width - margin;
      }
      this.menuEl.style.top = "".concat(Math.round(top), "px");
      this.menuEl.style.left = "".concat(Math.round(left), "px");
      this.menuEl.style.visibility = '';
    }
  }, {
    key: "attachMenuEvents",
    value: function attachMenuEvents() {
      var _this3 = this;
      if (!this.menuEl) {
        return;
      }
      this.menuEl.querySelectorAll('.item').forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var actionId = button.getAttribute('data-action');
          var action = _this3.actions.find(function (item) {
            return item.id === actionId;
          });
          _this3.close();
          if (action !== null && action !== void 0 && action.handler) {
            action.handler();
          }
        });
      });
    }
  }, {
    key: "addDismissListeners",
    value: function addDismissListeners() {
      var _document$querySelect;
      document.addEventListener('mousedown', this.onDocumentPointerDown, true);
      document.addEventListener('touchstart', this.onDocumentPointerDown, true);
      document.addEventListener('keydown', this.onDocumentKeyDown);
      var scroller = ((_document$querySelect = document.querySelector('.manager .body')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.closest('.manager')) || document.querySelector('.manager') || document.querySelector('#saito-container') || document.querySelector('.saito-container');
      if (scroller) {
        scroller.addEventListener('scroll', this.onScrollClose, {
          passive: true
        });
        this.scrollContainer = scroller;
      }
    }
  }, {
    key: "removeDismissListeners",
    value: function removeDismissListeners() {
      document.removeEventListener('mousedown', this.onDocumentPointerDown, true);
      document.removeEventListener('touchstart', this.onDocumentPointerDown, true);
      document.removeEventListener('keydown', this.onDocumentKeyDown);
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.onScrollClose);
        this.scrollContainer = null;
      }
    }
  }, {
    key: "onDocumentPointerDown",
    value: function onDocumentPointerDown(e) {
      var _this$menuEl2, _this$anchor;
      if (!this.isOpen) {
        return;
      }
      var target = e.target;
      if ((_this$menuEl2 = this.menuEl) !== null && _this$menuEl2 !== void 0 && _this$menuEl2.contains(target)) {
        return;
      }
      if ((_this$anchor = this.anchor) !== null && _this$anchor !== void 0 && _this$anchor.contains(target)) {
        return;
      }
      this.close();
    }
  }, {
    key: "onDocumentKeyDown",
    value: function onDocumentKeyDown(e) {
      if (!this.isOpen || e.key !== 'Escape') {
        return;
      }
      e.preventDefault();
      this.close();
    }
  }, {
    key: "onScrollClose",
    value: function onScrollClose() {
      if (this.isOpen) {
        this.close();
      }
    }
  }]);
}();
module.exports = TweetMenu;